export async function resolveInertiaPage(pages, name) {
  const loadPage = pages[`../pages/${name}.jsx`];
  if (!loadPage) throw new Error(`Page not found: ${name}`);

  return loadPage();
}
